import React from 'react';
import './Contact.less';

const imageUrl = (title) => {
  return `/imgs/${title}.png`;
};

function Contact({phone, email, company}) {
  return (
    <div className='AppContact'>
      <div>
        <img src={imageUrl('extra_phone')} alt='phone'/>
        <div style={{display: 'none'}}>
          <div>联系电话：</div>
          <div>{phone}</div>
          <div>联系邮箱：</div>
          <div>{email}</div>
        </div>
      </div>
      <div>
        <img src={imageUrl('extra_2dcode')} alt='2dcode'/>
        <div style={{display: 'none'}}>
          <div><img src={imageUrl('footer_2d_code')} alt='2dcode'/></div>
          <div>{`扫一扫关注${company}`}</div>
          <div>更多详情</div>
        </div>
      </div>
      <div onClick={() => window.scrollTo(0, 0)}>
        <img src={imageUrl('extra_top')} alt='top'/>
      </div>
    </div>
  );
}

export default Contact;


// WEBPACK FOOTER //
// ./src/routes/App/Contact.js